import { gql } from "graphql-tag";

export const CREATE_ANALYTICS_SHARE_LINK = gql`
  mutation CreateAnalyticsShareLink($input: CreateAnalyticsShareLinkInput!) {
    createAnalyticsShareLink(input: $input) {
      token
      expiresAt
    }
  }
`;
